
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5026"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5026"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("22TSl", function(module, exports) {
module.exports = $parcel$import("gKeNX").then(()=>parcelRequire('kLuDQ'));

});

var $ff380f74ec9ff823$exports = {};
$parcel$extendImportMap({
    "2VhPn": "GitHub-Mark-120px-plus.2297eca4.png",
    "aqvxB": "calculate-worker.5dd1b086.js",
    "gKeNX": "redos-detector-version.042559b3.js"
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $a6c50b5ab0875945$var$extendStatics = function(d, b) {
    $a6c50b5ab0875945$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a6c50b5ab0875945$var$extendStatics(d, b);
};
function $a6c50b5ab0875945$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a6c50b5ab0875945$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a6c50b5ab0875945$export$18ce0697a983be9b = function() {
    $a6c50b5ab0875945$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a6c50b5ab0875945$export$18ce0697a983be9b.apply(this, arguments);
};
function $a6c50b5ab0875945$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a6c50b5ab0875945$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a6c50b5ab0875945$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a6c50b5ab0875945$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a6c50b5ab0875945$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a6c50b5ab0875945$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a6c50b5ab0875945$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a6c50b5ab0875945$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a6c50b5ab0875945$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a6c50b5ab0875945$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a6c50b5ab0875945$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a6c50b5ab0875945$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a6c50b5ab0875945$export$45d3717a4c69092e(o, m, p);
}
function $a6c50b5ab0875945$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a6c50b5ab0875945$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a6c50b5ab0875945$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a6c50b5ab0875945$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a6c50b5ab0875945$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a6c50b5ab0875945$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a6c50b5ab0875945$export$10c90e4f7922046c(v) {
    return this instanceof $a6c50b5ab0875945$export$10c90e4f7922046c ? (this.v = v, this) : new $a6c50b5ab0875945$export$10c90e4f7922046c(v);
}
function $a6c50b5ab0875945$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a6c50b5ab0875945$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a6c50b5ab0875945$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a6c50b5ab0875945$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a6c50b5ab0875945$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a6c50b5ab0875945$export$19a8beecd37a4c45 === "function" ? $a6c50b5ab0875945$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a6c50b5ab0875945$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a6c50b5ab0875945$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $a6c50b5ab0875945$var$ownKeys = function(o) {
    $a6c50b5ab0875945$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $a6c50b5ab0875945$var$ownKeys(o);
};
function $a6c50b5ab0875945$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $a6c50b5ab0875945$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $a6c50b5ab0875945$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $a6c50b5ab0875945$var$__setModuleDefault(result, mod);
    return result;
}
function $a6c50b5ab0875945$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a6c50b5ab0875945$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a6c50b5ab0875945$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a6c50b5ab0875945$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a6c50b5ab0875945$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a6c50b5ab0875945$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a6c50b5ab0875945$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a6c50b5ab0875945$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $a6c50b5ab0875945$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $a6c50b5ab0875945$export$2e2bcd8739ae039 = {
    __extends: $a6c50b5ab0875945$export$a8ba968b8961cb8a,
    __assign: $a6c50b5ab0875945$export$18ce0697a983be9b,
    __rest: $a6c50b5ab0875945$export$3c9a16f847548506,
    __decorate: $a6c50b5ab0875945$export$29e00dfd3077644b,
    __param: $a6c50b5ab0875945$export$d5ad3fd78186038f,
    __esDecorate: $a6c50b5ab0875945$export$3a84e1ae4e97e9b0,
    __runInitializers: $a6c50b5ab0875945$export$d831c04e792af3d,
    __propKey: $a6c50b5ab0875945$export$6a2a36740a146cb8,
    __setFunctionName: $a6c50b5ab0875945$export$d1a06452d3489bc7,
    __metadata: $a6c50b5ab0875945$export$f1db080c865becb9,
    __awaiter: $a6c50b5ab0875945$export$1050f835b63b671e,
    __generator: $a6c50b5ab0875945$export$67ebef60e6f28a6,
    __createBinding: $a6c50b5ab0875945$export$45d3717a4c69092e,
    __exportStar: $a6c50b5ab0875945$export$f33643c0debef087,
    __values: $a6c50b5ab0875945$export$19a8beecd37a4c45,
    __read: $a6c50b5ab0875945$export$8d051b38c9118094,
    __spread: $a6c50b5ab0875945$export$afc72e2116322959,
    __spreadArrays: $a6c50b5ab0875945$export$6388937ca91ccae8,
    __spreadArray: $a6c50b5ab0875945$export$1216008129fb82ed,
    __await: $a6c50b5ab0875945$export$10c90e4f7922046c,
    __asyncGenerator: $a6c50b5ab0875945$export$e427f37a30a4de9b,
    __asyncDelegator: $a6c50b5ab0875945$export$bbd80228419bb833,
    __asyncValues: $a6c50b5ab0875945$export$e3b29a3d6162315f,
    __makeTemplateObject: $a6c50b5ab0875945$export$4fb47efe1390b86f,
    __importStar: $a6c50b5ab0875945$export$c21735bcef00d192,
    __importDefault: $a6c50b5ab0875945$export$da59b14a69baef04,
    __classPrivateFieldGet: $a6c50b5ab0875945$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a6c50b5ab0875945$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a6c50b5ab0875945$export$81fdc39f203e4e04,
    __addDisposableResource: $a6c50b5ab0875945$export$88ac25d8e944e405,
    __disposeResources: $a6c50b5ab0875945$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $a6c50b5ab0875945$export$889dfb5d17574b0b
};


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9183d483313437e5$var$t = globalThis, $9183d483313437e5$export$b4d10f6001c083c2 = $9183d483313437e5$var$t.ShadowRoot && (void 0 === $9183d483313437e5$var$t.ShadyCSS || $9183d483313437e5$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $9183d483313437e5$var$s = Symbol(), $9183d483313437e5$var$o = new WeakMap;
class $9183d483313437e5$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $9183d483313437e5$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($9183d483313437e5$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $9183d483313437e5$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $9183d483313437e5$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $9183d483313437e5$export$8d80f9cac07cdb3 = (t)=>new $9183d483313437e5$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $9183d483313437e5$var$s), $9183d483313437e5$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $9183d483313437e5$export$505d1e8739bad805(o, t, $9183d483313437e5$var$s);
}, $9183d483313437e5$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($9183d483313437e5$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $9183d483313437e5$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $9183d483313437e5$export$ee69dfd951e24778 = $9183d483313437e5$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $9183d483313437e5$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $3c50cd659742dc82$var$i, defineProperty: $3c50cd659742dc82$var$e, getOwnPropertyDescriptor: $3c50cd659742dc82$var$h, getOwnPropertyNames: $3c50cd659742dc82$var$r, getOwnPropertySymbols: $3c50cd659742dc82$var$o, getPrototypeOf: $3c50cd659742dc82$var$n } = Object, $3c50cd659742dc82$var$a = globalThis, $3c50cd659742dc82$var$c = $3c50cd659742dc82$var$a.trustedTypes, $3c50cd659742dc82$var$l = $3c50cd659742dc82$var$c ? $3c50cd659742dc82$var$c.emptyScript : "", $3c50cd659742dc82$var$p = $3c50cd659742dc82$var$a.reactiveElementPolyfillSupport, $3c50cd659742dc82$var$d = (t, s)=>t, $3c50cd659742dc82$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $3c50cd659742dc82$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $3c50cd659742dc82$export$53a6892c50694894 = (t, s)=>!$3c50cd659742dc82$var$i(t, s), $3c50cd659742dc82$var$b = {
    attribute: !0,
    type: String,
    converter: $3c50cd659742dc82$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $3c50cd659742dc82$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $3c50cd659742dc82$var$a.litPropertyMetadata ??= new WeakMap;
class $3c50cd659742dc82$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $3c50cd659742dc82$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $3c50cd659742dc82$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $3c50cd659742dc82$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $3c50cd659742dc82$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($3c50cd659742dc82$var$d("elementProperties"))) return;
        const t = $3c50cd659742dc82$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($3c50cd659742dc82$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($3c50cd659742dc82$var$d("properties"))) {
            const t = this.properties, s = [
                ...$3c50cd659742dc82$var$r(t),
                ...$3c50cd659742dc82$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $9183d483313437e5$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $9183d483313437e5$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $9183d483313437e5$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $3c50cd659742dc82$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $3c50cd659742dc82$export$7312b35fbf521afb;
            this._$Em = e, this[e] = h.fromAttribute(s, t.type) ?? this._$Ej?.get(e) ?? null, this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            const e = this.constructor, h = this[t];
            if (i ??= e.getPropertyOptions(t), !((i.hasChanged ?? $3c50cd659742dc82$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(e._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$3c50cd659742dc82$export$c7c07a37856565d.elementStyles = [], $3c50cd659742dc82$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $3c50cd659742dc82$export$c7c07a37856565d[$3c50cd659742dc82$var$d("elementProperties")] = new Map, $3c50cd659742dc82$export$c7c07a37856565d[$3c50cd659742dc82$var$d("finalized")] = new Map, $3c50cd659742dc82$var$p?.({
    ReactiveElement: $3c50cd659742dc82$export$c7c07a37856565d
}), ($3c50cd659742dc82$var$a.reactiveElementVersions ??= []).push("2.1.0");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e943a7bafefa26a3$var$t = globalThis, $e943a7bafefa26a3$var$i = $e943a7bafefa26a3$var$t.trustedTypes, $e943a7bafefa26a3$var$s = $e943a7bafefa26a3$var$i ? $e943a7bafefa26a3$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e943a7bafefa26a3$var$e = "$lit$", $e943a7bafefa26a3$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e943a7bafefa26a3$var$o = "?" + $e943a7bafefa26a3$var$h, $e943a7bafefa26a3$var$n = `<${$e943a7bafefa26a3$var$o}>`, $e943a7bafefa26a3$var$r = document, $e943a7bafefa26a3$var$l = ()=>$e943a7bafefa26a3$var$r.createComment(""), $e943a7bafefa26a3$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e943a7bafefa26a3$var$a = Array.isArray, $e943a7bafefa26a3$var$u = (t)=>$e943a7bafefa26a3$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e943a7bafefa26a3$var$d = "[ \t\n\f\r]", $e943a7bafefa26a3$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e943a7bafefa26a3$var$v = /-->/g, $e943a7bafefa26a3$var$_ = />/g, $e943a7bafefa26a3$var$m = RegExp(`>|${$e943a7bafefa26a3$var$d}(?:([^\\s"'>=/]+)(${$e943a7bafefa26a3$var$d}*=${$e943a7bafefa26a3$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e943a7bafefa26a3$var$p = /'/g, $e943a7bafefa26a3$var$g = /"/g, $e943a7bafefa26a3$var$$ = /^(?:script|style|textarea|title)$/i, $e943a7bafefa26a3$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e943a7bafefa26a3$export$c0bb0b647f701bb5 = $e943a7bafefa26a3$var$y(1), $e943a7bafefa26a3$export$7ed1367e7fa1ad68 = $e943a7bafefa26a3$var$y(2), $e943a7bafefa26a3$export$47d5b44d225be5b4 = $e943a7bafefa26a3$var$y(3), $e943a7bafefa26a3$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e943a7bafefa26a3$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e943a7bafefa26a3$var$A = new WeakMap, $e943a7bafefa26a3$var$C = $e943a7bafefa26a3$var$r.createTreeWalker($e943a7bafefa26a3$var$r, 129);
function $e943a7bafefa26a3$var$P(t, i) {
    if (!$e943a7bafefa26a3$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e943a7bafefa26a3$var$s ? $e943a7bafefa26a3$var$s.createHTML(i) : i;
}
const $e943a7bafefa26a3$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e943a7bafefa26a3$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e943a7bafefa26a3$var$f ? "!--" === u[1] ? c = $e943a7bafefa26a3$var$v : void 0 !== u[1] ? c = $e943a7bafefa26a3$var$_ : void 0 !== u[2] ? ($e943a7bafefa26a3$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e943a7bafefa26a3$var$m) : void 0 !== u[3] && (c = $e943a7bafefa26a3$var$m) : c === $e943a7bafefa26a3$var$m ? ">" === u[0] ? (c = r ?? $e943a7bafefa26a3$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e943a7bafefa26a3$var$m : '"' === u[3] ? $e943a7bafefa26a3$var$g : $e943a7bafefa26a3$var$p) : c === $e943a7bafefa26a3$var$g || c === $e943a7bafefa26a3$var$p ? c = $e943a7bafefa26a3$var$m : c === $e943a7bafefa26a3$var$v || c === $e943a7bafefa26a3$var$_ ? c = $e943a7bafefa26a3$var$f : (c = $e943a7bafefa26a3$var$m, r = void 0);
        const x = c === $e943a7bafefa26a3$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e943a7bafefa26a3$var$f ? s + $e943a7bafefa26a3$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e943a7bafefa26a3$var$e + s.slice(d) + $e943a7bafefa26a3$var$h + x) : s + $e943a7bafefa26a3$var$h + (-2 === d ? i : x);
    }
    return [
        $e943a7bafefa26a3$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $e943a7bafefa26a3$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e943a7bafefa26a3$var$V(t, s);
        if (this.el = $e943a7bafefa26a3$var$N.createElement(f, n), $e943a7bafefa26a3$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e943a7bafefa26a3$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e943a7bafefa26a3$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e943a7bafefa26a3$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e943a7bafefa26a3$var$H : "?" === e[1] ? $e943a7bafefa26a3$var$I : "@" === e[1] ? $e943a7bafefa26a3$var$L : $e943a7bafefa26a3$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($e943a7bafefa26a3$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e943a7bafefa26a3$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e943a7bafefa26a3$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e943a7bafefa26a3$var$i ? $e943a7bafefa26a3$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e943a7bafefa26a3$var$l()), $e943a7bafefa26a3$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e943a7bafefa26a3$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e943a7bafefa26a3$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e943a7bafefa26a3$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e943a7bafefa26a3$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e943a7bafefa26a3$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e943a7bafefa26a3$var$S(t, i, s = t, e) {
    if (i === $e943a7bafefa26a3$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e943a7bafefa26a3$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e943a7bafefa26a3$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $e943a7bafefa26a3$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e943a7bafefa26a3$var$r).importNode(i, !0);
        $e943a7bafefa26a3$var$C.currentNode = e;
        let h = $e943a7bafefa26a3$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e943a7bafefa26a3$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e943a7bafefa26a3$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e943a7bafefa26a3$var$C.nextNode(), o++);
        }
        return $e943a7bafefa26a3$var$C.currentNode = $e943a7bafefa26a3$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e943a7bafefa26a3$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e943a7bafefa26a3$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e943a7bafefa26a3$var$S(this, t, i), $e943a7bafefa26a3$var$c(t) ? t === $e943a7bafefa26a3$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e943a7bafefa26a3$export$45b790e32b2810ee && this._$AR(), this._$AH = $e943a7bafefa26a3$export$45b790e32b2810ee) : t !== this._$AH && t !== $e943a7bafefa26a3$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e943a7bafefa26a3$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e943a7bafefa26a3$export$45b790e32b2810ee && $e943a7bafefa26a3$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e943a7bafefa26a3$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e943a7bafefa26a3$var$N.createElement($e943a7bafefa26a3$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e943a7bafefa26a3$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e943a7bafefa26a3$var$A.get(t.strings);
        return void 0 === i && $e943a7bafefa26a3$var$A.set(t.strings, i = new $e943a7bafefa26a3$var$N(t)), i;
    }
    k(t) {
        $e943a7bafefa26a3$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e943a7bafefa26a3$var$R(this.O($e943a7bafefa26a3$var$l()), this.O($e943a7bafefa26a3$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e943a7bafefa26a3$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e943a7bafefa26a3$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e943a7bafefa26a3$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e943a7bafefa26a3$var$S(this, t, i, 0), o = !$e943a7bafefa26a3$var$c(t) || t !== this._$AH && t !== $e943a7bafefa26a3$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e943a7bafefa26a3$var$S(this, e[s + n], i, n), r === $e943a7bafefa26a3$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e943a7bafefa26a3$var$c(r) || r !== this._$AH[n], r === $e943a7bafefa26a3$export$45b790e32b2810ee ? t = $e943a7bafefa26a3$export$45b790e32b2810ee : t !== $e943a7bafefa26a3$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e943a7bafefa26a3$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e943a7bafefa26a3$var$H extends $e943a7bafefa26a3$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e943a7bafefa26a3$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e943a7bafefa26a3$var$I extends $e943a7bafefa26a3$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e943a7bafefa26a3$export$45b790e32b2810ee);
    }
}
class $e943a7bafefa26a3$var$L extends $e943a7bafefa26a3$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e943a7bafefa26a3$var$S(this, t, i, 0) ?? $e943a7bafefa26a3$export$45b790e32b2810ee) === $e943a7bafefa26a3$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e943a7bafefa26a3$export$45b790e32b2810ee && s !== $e943a7bafefa26a3$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e943a7bafefa26a3$export$45b790e32b2810ee && (s === $e943a7bafefa26a3$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e943a7bafefa26a3$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e943a7bafefa26a3$var$S(this, t);
    }
}
const $e943a7bafefa26a3$export$8613d1ca9052b22e = {
    M: $e943a7bafefa26a3$var$e,
    P: $e943a7bafefa26a3$var$h,
    A: $e943a7bafefa26a3$var$o,
    C: 1,
    L: $e943a7bafefa26a3$var$V,
    R: $e943a7bafefa26a3$var$M,
    D: $e943a7bafefa26a3$var$u,
    V: $e943a7bafefa26a3$var$S,
    I: $e943a7bafefa26a3$var$R,
    H: $e943a7bafefa26a3$var$k,
    N: $e943a7bafefa26a3$var$I,
    U: $e943a7bafefa26a3$var$L,
    B: $e943a7bafefa26a3$var$H,
    F: $e943a7bafefa26a3$var$z
}, $e943a7bafefa26a3$var$j = $e943a7bafefa26a3$var$t.litHtmlPolyfillSupport;
$e943a7bafefa26a3$var$j?.($e943a7bafefa26a3$var$N, $e943a7bafefa26a3$var$R), ($e943a7bafefa26a3$var$t.litHtmlVersions ??= []).push("3.3.0");
const $e943a7bafefa26a3$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e943a7bafefa26a3$var$R(i.insertBefore($e943a7bafefa26a3$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $eaddb0c0aed379ed$var$s = globalThis;
class $eaddb0c0aed379ed$export$3f2f9f5909897157 extends (0, $3c50cd659742dc82$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e943a7bafefa26a3$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $e943a7bafefa26a3$export$9c068ae9cc5db4e8;
    }
}
$eaddb0c0aed379ed$export$3f2f9f5909897157._$litElement$ = !0, $eaddb0c0aed379ed$export$3f2f9f5909897157["finalized"] = !0, $eaddb0c0aed379ed$var$s.litElementHydrateSupport?.({
    LitElement: $eaddb0c0aed379ed$export$3f2f9f5909897157
});
const $eaddb0c0aed379ed$var$o = $eaddb0c0aed379ed$var$s.litElementPolyfillSupport;
$eaddb0c0aed379ed$var$o?.({
    LitElement: $eaddb0c0aed379ed$export$3f2f9f5909897157
});
const $eaddb0c0aed379ed$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($eaddb0c0aed379ed$var$s.litElementVersions ??= []).push("4.2.0");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $75efd67fc02dc46f$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $93dae87feeb74050$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $3c50cd659742dc82$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $3c50cd659742dc82$export$53a6892c50694894)
}, $93dae87feeb74050$export$8d623b1670eb40f4 = (t = $93dae87feeb74050$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $93dae87feeb74050$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $93dae87feeb74050$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $28d684a763952cf1$export$ca000e230c0caa3e(r) {
    return (0, $93dae87feeb74050$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $528acee280b88e24$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $17c3a7a9f6dbd306$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8f42ba867b1b0441$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $17c3a7a9f6dbd306$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $17c3a7a9f6dbd306$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $c2f16e379f7f88df$var$e;
function $c2f16e379f7f88df$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $17c3a7a9f6dbd306$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($c2f16e379f7f88df$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $6a823e2f06a483b0$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $17c3a7a9f6dbd306$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1d4aa5a12793a205$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $17c3a7a9f6dbd306$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3443fb401a478805$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $17c3a7a9f6dbd306$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}






/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $cca685bfb019faa5$var$t } = (0, $e943a7bafefa26a3$export$8613d1ca9052b22e), $cca685bfb019faa5$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $cca685bfb019faa5$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $cca685bfb019faa5$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $cca685bfb019faa5$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $cca685bfb019faa5$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $cca685bfb019faa5$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $cca685bfb019faa5$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $cca685bfb019faa5$var$s = ()=>document.createComment(""), $cca685bfb019faa5$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($cca685bfb019faa5$var$s(), l), c = e.insertBefore($cca685bfb019faa5$var$s(), l);
        n = new $cca685bfb019faa5$var$t(i, c, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, c = i !== o;
        if (c) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || c) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $cca685bfb019faa5$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $cca685bfb019faa5$var$u = {}, $cca685bfb019faa5$export$ea70d9dd5965b1c8 = (o, t = $cca685bfb019faa5$var$u)=>o._$AH = t, $cca685bfb019faa5$export$59e9bce518cde500 = (o)=>o._$AH, $cca685bfb019faa5$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $cca685bfb019faa5$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5f5fe606530e04e3$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $5f5fe606530e04e3$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $5f5fe606530e04e3$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8aac015991ee9c48$var$s = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $8aac015991ee9c48$var$s(i, t);
    return !0;
}, $8aac015991ee9c48$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $8aac015991ee9c48$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $8aac015991ee9c48$var$c(t);
    }
};
function $8aac015991ee9c48$var$h(i) {
    void 0 !== this._$AN ? ($8aac015991ee9c48$var$o(this), this._$AM = i, $8aac015991ee9c48$var$r(this)) : this._$AM = i;
}
function $8aac015991ee9c48$var$n(i, t = !1, e = 0) {
    const r = this._$AH, h = this._$AN;
    if (void 0 !== h && 0 !== h.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$8aac015991ee9c48$var$s(r[i], !1), $8aac015991ee9c48$var$o(r[i]);
            else null != r && ($8aac015991ee9c48$var$s(r, !1), $8aac015991ee9c48$var$o(r));
        } else $8aac015991ee9c48$var$s(this, i);
    }
}
const $8aac015991ee9c48$var$c = (i)=>{
    i.type == (0, $5f5fe606530e04e3$export$9ba3b3f20a85bfa).CHILD && (i._$AP ??= $8aac015991ee9c48$var$n, i._$AQ ??= $8aac015991ee9c48$var$h);
};
class $8aac015991ee9c48$export$7d025501802325e extends (0, $5f5fe606530e04e3$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $8aac015991ee9c48$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($8aac015991ee9c48$var$s(this, i), $8aac015991ee9c48$var$o(this));
    }
    setValue(t) {
        if ((0, $cca685bfb019faa5$export$7f431ad0fff82fd9)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6c8e96a4880b3422$export$7d1e3a5e95ceca43 = ()=>new $6c8e96a4880b3422$var$h;
class $6c8e96a4880b3422$var$h {
}
const $6c8e96a4880b3422$var$o = new WeakMap, $6c8e96a4880b3422$export$eff4d24c3ff7876e = (0, $5f5fe606530e04e3$export$99b43ad1ed32e735)(class extends (0, $8aac015991ee9c48$export$7d025501802325e) {
    render(i) {
        return 0, $e943a7bafefa26a3$export$45b790e32b2810ee;
    }
    update(i, [s]) {
        const e = s !== this.G;
        return e && void 0 !== this.G && this.rt(void 0), (e || this.lt !== this.ct) && (this.G = s, this.ht = i.options?.host, this.rt(this.ct = i.element)), $e943a7bafefa26a3$export$45b790e32b2810ee;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.G) {
            const i = this.ht ?? globalThis;
            let s = $6c8e96a4880b3422$var$o.get(i);
            void 0 === s && (s = new WeakMap, $6c8e96a4880b3422$var$o.set(i, s)), void 0 !== s.get(this.G) && this.G.call(this.ht, void 0), s.set(this.G, t), void 0 !== t && this.G.call(this.ht, t);
        } else this.G.value = t;
    }
    get lt() {
        return "function" == typeof this.G ? $6c8e96a4880b3422$var$o.get(this.ht ?? globalThis)?.get(this.G) : this.G?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});





const $1de3babb91df13b2$export$ed32643c9618a26 = (0, $9183d483313437e5$export$dbf350e5966cf602)`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;
const $1de3babb91df13b2$export$5e032988b71f6158 = (0, $9183d483313437e5$export$dbf350e5966cf602)`
  :host {
    display: block;
  }
`;
const $1de3babb91df13b2$export$ac33ccbe5c3bf528 = (0, $9183d483313437e5$export$dbf350e5966cf602)`
  table,
  tbody,
  th,
  tr,
  td {
    all: unset;
  }

  table {
    display: table;
    border-collapse: collapse;
  }

  tbody {
    display: table-row-group;
  }

  tr {
    display: table-row;
  }

  th,
  td {
    display: table-cell;
  }
`;
const $1de3babb91df13b2$export$e98b8c2ec48aa0c8 = (0, $9183d483313437e5$export$dbf350e5966cf602)`
  p {
    all: unset;
    display: block;
  }
`;
const $1de3babb91df13b2$export$d836555d4d3fc310 = (0, $9183d483313437e5$export$dbf350e5966cf602)`
  h1 {
    all: unset;
    display: block;
  }
`;
const $1de3babb91df13b2$export$605d5d2be7156deb = (0, $9183d483313437e5$export$dbf350e5966cf602)`
  a {
    all: unset;
    cursor: pointer;
  }
`;
const $1de3babb91df13b2$export$5d481d1cf311f83f = (0, $9183d483313437e5$export$dbf350e5966cf602)`
  footer {
    all: unset;
    display: block;
  }
`;








/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0ffd902fa48b79f5$export$28cf49ad70f82d12 = (0, $5f5fe606530e04e3$export$99b43ad1ed32e735)(class extends (0, $5f5fe606530e04e3$export$befdefbdce210f91) {
    constructor(r){
        if (super(r), r.type !== (0, $5f5fe606530e04e3$export$9ba3b3f20a85bfa).PROPERTY && r.type !== (0, $5f5fe606530e04e3$export$9ba3b3f20a85bfa).ATTRIBUTE && r.type !== (0, $5f5fe606530e04e3$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $cca685bfb019faa5$export$7f431ad0fff82fd9)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $e943a7bafefa26a3$export$9c068ae9cc5db4e8) || t === (0, $e943a7bafefa26a3$export$45b790e32b2810ee)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $5f5fe606530e04e3$export$9ba3b3f20a85bfa).PROPERTY) {
            if (t === o[l]) return 0, $e943a7bafefa26a3$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $5f5fe606530e04e3$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $e943a7bafefa26a3$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $5f5fe606530e04e3$export$9ba3b3f20a85bfa).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $e943a7bafefa26a3$export$9c068ae9cc5db4e8;
        return (0, $cca685bfb019faa5$export$ea70d9dd5965b1c8)(i), t;
    }
});





class $d4616b0af25354a3$export$f5b8910cec6cf069 extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {
            value: {
                type: String
            },
            flag: {
                type: String
            }
        };
    }
    constructor(){
        super(), this._onCheckboxClick = (flag)=>{
            if (this.flag === flag) this.flag = '';
            else this.flag = flag;
            this.dispatchEvent(new CustomEvent('my-change', {
                bubbles: true,
                composed: true
            }));
        }, this._onChange = (event)=>{
            this.value = event.target.value;
            this.dispatchEvent(new CustomEvent('my-change', {
                bubbles: true,
                composed: true
            }));
        };
        this.value = '';
        this.flag = '';
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .container {
        display: grid;
        grid-template-columns: max-content 1fr max-content max-content;
        width: 100%;
        align-items: center;
        grid-gap: 0.25em;
      }

      .input {
        display: block;
        width: 100%;
        padding: 0.4rem 0.5rem;
      }

      .slash,
      .flags,
      .input {
        font-size: 1.5rem;
        font-family: Arial;
      }

      .flags {
        display: flex;
        gap: 0.5rem;
      }

      .flags .checkbox {
        margin-right: 0.4em;
        width: 1rem;
        height: 1rem;
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div class="container">
      <div class="slash">/</div>
      <input
        data-test="pattern-input"
        class="input"
        type="text"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
        .value=${(0, $0ffd902fa48b79f5$export$28cf49ad70f82d12)(this.value)}
        @input=${this._onChange}
        placeholder="Enter RegEx pattern..."
      />
      <div class="slash">/</div>
      <div class="flags">
        <div title="Case insensitive">
          <input
            data-test="case-insensitive"
            id="case-insensitive"
            class="checkbox"
            type="checkbox"
            .checked=${(0, $0ffd902fa48b79f5$export$28cf49ad70f82d12)(this.flag === 'i')}
            @click=${()=>this._onCheckboxClick('i')}
          /><label for="case-insensitive">i</label>
        </div>
        <div title="Unicode">
          <input
            data-test="unicode"
            id="unicode"
            class="checkbox"
            type="checkbox"
            .checked=${(0, $0ffd902fa48b79f5$export$28cf49ad70f82d12)(this.flag === 'u')}
            @click=${()=>this._onCheckboxClick('u')}
          /><label for="unicode">u</label>
        </div>
      </div>
    </div>`;
    }
}
$d4616b0af25354a3$export$f5b8910cec6cf069 = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-input')
], $d4616b0af25354a3$export$f5b8910cec6cf069);








/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $e1fa733e4a98e69d$export$3bebd1f0e3943985 extends (0, $5f5fe606530e04e3$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.it = (0, $e943a7bafefa26a3$export$45b790e32b2810ee), i.type !== (0, $5f5fe606530e04e3$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $e943a7bafefa26a3$export$45b790e32b2810ee) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $e943a7bafefa26a3$export$9c068ae9cc5db4e8)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$e1fa733e4a98e69d$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $e1fa733e4a98e69d$export$3bebd1f0e3943985.resultType = 1;
const $e1fa733e4a98e69d$export$b6e69390c23686fb = (0, $5f5fe606530e04e3$export$99b43ad1ed32e735)($e1fa733e4a98e69d$export$3bebd1f0e3943985);





function $4db6a6d1531f2d42$export$eab69063eac8acfa(input) {
    return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`${input.split('').map((character)=>{
        return character === ' ' ? (0, $e1fa733e4a98e69d$export$b6e69390c23686fb)('&nbsp') : character;
    })}`;
}
function $4db6a6d1531f2d42$export$4ff57cfbef41b5c5(input) {
    return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`${input.split('').map((character)=>{
        return character === '\n' ? (0, $e1fa733e4a98e69d$export$b6e69390c23686fb)('<br />') : character;
    })}`;
}


class $70a6493f0af94e70$export$47606a6ae3eaed8e extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {
            highlightA: {
                type: Array
            },
            highlightB: {
                type: Array
            },
            included: {
                type: Array
            },
            pattern: {
                type: String
            }
        };
    }
    constructor(){
        super();
        this.highlightA = [];
        this.highlightB = [];
        this.included = [];
        this.pattern = '';
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .character {
        font-family: monospace;
        display: inline-block;
        font-size: 1.5rem;
        border-bottom-color: transparent;
        border-bottom-width: 2px;
        border-bottom-style: solid;
        color: #808080;
        transition: border-bottom-color 0.2s;
        background-color: var(--source-color);
      }

      .included {
        color: #000000;
      }

      .highlight-a {
        border-bottom-color: var(--a-side-color);
      }

      .highlight-b {
        border-bottom-color: var(--b-side-color);
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div data-test="pattern">
      ${this.pattern.split('').map((character, i)=>{
            const classes = [
                'character',
                this.included.includes(i) && 'included',
                this.highlightA.includes(i) && 'highlight-a',
                this.highlightB.includes(i) && 'highlight-b'
            ].filter(Boolean).join(' ');
            return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<span class="${classes}">${(0, $4db6a6d1531f2d42$export$eab69063eac8acfa)(character)}</span>`;
        })}
    </div>`;
    }
}
$70a6493f0af94e70$export$47606a6ae3eaed8e = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-pattern')
], $70a6493f0af94e70$export$47606a6ae3eaed8e);







function $312bc04c6986c4e4$export$49bb65c2ea163039(start, end) {
    const res = [];
    for(let i = start; i < end; i++)res.push(i);
    return res;
}


function $a97ac150c5d82f70$export$62c3ee984ad46566(a, b) {
    if (a.size !== b.size) return false;
    return new Set([
        ...a,
        ...b
    ]).size === a.size;
}


class $19eb4b05967c3ec6$export$8fdcabde73f49165 extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {
            trail: {
                type: Object
            }
        };
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$ac33ccbe5c3bf528),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .table {
        font-family: var(--font-family);
        text-align: center;
        font-size: 1rem;
        color: #000000;
      }

      .table th {
        font-weight: bold;
      }

      .table td,
      .table th {
        border: 1px solid #999;
        padding: 0.5rem;
        vertical-align: middle;
        position: relative;
      }

      .table td {
        font-family: monospace;
      }

      .table tr {
        background-color: #ffffff;

        transition: background-color 0.2s;
      }

      .table .result-row {
        cursor: default;
      }

      .table .result-row:hover {
        background-color: #ddddff;
      }

      .source {
        background-color: var(--source-color);
      }

      .table .option-1,
      .table .option-2 {
        border-bottom-width: 2px;
      }

      .table .option-1 {
        border-bottom-color: var(--a-side-color);
      }

      .table .option-2 {
        border-bottom-color: var(--b-side-color);
      }
    `
        ];
    }
    updated() {
        this._updateOffsets();
    }
    _updateOffsets() {
        const el = this.shadowRoot.querySelector('tr.result-row:hover');
        let aOffsets = new Set();
        let bOffsets = new Set();
        if (el) {
            const index = parseInt(el.dataset.index, 10);
            const entry = this.trail.trail[index];
            const getOffsets = (entrySide)=>{
                const sideOffsets = new Set();
                (0, $312bc04c6986c4e4$export$49bb65c2ea163039)(entrySide.node.start.offset, entrySide.node.end.offset).forEach((offset)=>sideOffsets.add(offset));
                entrySide.backreferenceStack.forEach((backreference)=>{
                    (0, $312bc04c6986c4e4$export$49bb65c2ea163039)(backreference.node.start.offset, backreference.node.end.offset).forEach((offset)=>sideOffsets.add(offset));
                });
                return sideOffsets;
            };
            aOffsets = getOffsets(entry.a);
            bOffsets = getOffsets(entry.b);
        }
        if ((0, $a97ac150c5d82f70$export$62c3ee984ad46566)(this.highlightedA, aOffsets) && (0, $a97ac150c5d82f70$export$62c3ee984ad46566)(this.highlightedB, bOffsets)) return;
        this.highlightedA = aOffsets;
        this.highlightedB = bOffsets;
        const event = new CustomEvent('my-result-change', {
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(event);
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div data-test="result">
      <table class="table">
        <tbody>
          <tr>
            <th colspan="2" class="option-1">Option 1</th>
            <th colspan="2" class="option-2">Option 2</th>
          </tr>
          <tr>
            <th>Offset</th>
            <th>Character</th>
            <th>Character</th>
            <th>Offset</th>
          </tr>

          ${this.trail.trail.map((entry, i)=>{
            return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`
              <tr
                class="result-row"
                data-index=${i}
                @mouseenter=${this._updateOffsets}
                @mouseleave=${this._updateOffsets}
              >
                <td>${entry.a.node.start.offset}</td>
                <td>
                  <span class="source">${(0, $4db6a6d1531f2d42$export$eab69063eac8acfa)(entry.a.node.source)}</span>
                </td>
                <td>
                  <span class="source">${(0, $4db6a6d1531f2d42$export$eab69063eac8acfa)(entry.b.node.source)}</span>
                </td>
                <td>${entry.b.node.start.offset}</td>
              </tr>
            `;
        })}
        </tbody>
      </table>
    </div>`;
    }
    constructor(...args){
        super(...args), this.highlightedA = new Set(), this.highlightedB = new Set();
    }
}
$19eb4b05967c3ec6$export$8fdcabde73f49165 = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-result')
], $19eb4b05967c3ec6$export$8fdcabde73f49165);






const $757312490ceb46e4$var$errorToMessage = {
    hitMaxScore: 'Hit max score, so there may be more results than shown here.',
    hitMaxSteps: 'Hit maximum number of steps so there may be more results than shown here.',
    timedOut: 'Timed out so there may be more results than shown here.'
};
class $757312490ceb46e4$export$3faa64ddadde6a47 extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {
            error: {
                type: String
            }
        };
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$e98b8c2ec48aa0c8),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .message {
        font-size: 1rem;
        font-family: var(--font-family);
        padding: 0.2rem 0.5rem;
        background-color: #ffff00;
        color: #000000;
      }

      .icon {
        display: inline-block;
        width: 1.3rem;
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<p class="message">
      <span class="icon">⚠</span>${$757312490ceb46e4$var$errorToMessage[this.error]}
    </p>`;
    }
}
$757312490ceb46e4$export$3faa64ddadde6a47 = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-redos-error')
], $757312490ceb46e4$export$3faa64ddadde6a47);






class $7c56dbfcd2d41220$export$4f3bfd4ee83354d0 extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {
            score: {
                type: Number
            }
        };
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$e98b8c2ec48aa0c8),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .message {
        font-size: 1rem;
        font-family: var(--font-family);
        padding: 0.2rem 0.5rem;
        background-color: #6be96b;
        color: #000000;
      }

      .icon {
        display: inline-block;
        width: 1.3rem;
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<p class="message" data-test="redos-safe">
      <span class="icon">✔</span>This pattern is safe from ReDoS attacks.
      Score: ${this.score} 🎉
    </p>`;
    }
}
$7c56dbfcd2d41220$export$4f3bfd4ee83354d0 = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-redos-safe')
], $7c56dbfcd2d41220$export$4f3bfd4ee83354d0);






class $03fd493b506f67a3$export$d0220e4cf76847d9 extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {
            error: {
                type: String
            },
            maybe: {
                type: Boolean
            },
            score: {
                type: Number
            }
        };
    }
    constructor(){
        super();
        this.maybe = false;
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$e98b8c2ec48aa0c8),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .message {
        font-size: 1rem;
        font-family: var(--font-family);
        padding: 0.2rem 0.5rem;
        background-color: #ff8181;
        color: #000000;
      }

      .icon {
        display: inline-block;
        width: 1.3rem;
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<p class="message" data-test="redos-unsafe">
      <span class="icon">❌</span>This pattern
      ${this.maybe ? 'might not be' : 'is not'} safe from ReDoS attacks.
      ${this.score === Infinity ? `There may be infinite backtracks possible.` : `Score: ${this.score}`}
    </p>`;
    }
}
$03fd493b506f67a3$export$d0220e4cf76847d9 = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-redos-unsafe')
], $03fd493b506f67a3$export$d0220e4cf76847d9);







class $34c769987f4cba82$export$edf27be85e5f6da0 extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {
            message: {
                type: String
            }
        };
    }
    constructor(){
        super();
        this.message = '';
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$e98b8c2ec48aa0c8),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .message {
        font-size: 1rem;
        font-family: var(--font-family);
        padding: 0.2rem 0.5rem;
        background-color: #ffff00;
        color: #000000;
      }

      .icon {
        display: inline-block;
        width: 1.3rem;
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<p class="message">
      <span class="icon">⚠</span>${(0, $4db6a6d1531f2d42$export$4ff57cfbef41b5c5)(this.message)}
    </p>`;
    }
}
$34c769987f4cba82$export$edf27be85e5f6da0 = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-error')
], $34c769987f4cba82$export$edf27be85e5f6da0);






class $fdb1f0370693292f$export$669f6ea7d267feaf extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {};
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            // https://loading.io/css/
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .loading {
        text-align: center;
      }

      .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 5rem;
        height: 1rem;
      }
      .lds-ellipsis div {
        position: absolute;
        width: 1rem;
        height: 1rem;
        background: #d0d0d0;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
      }
      .lds-ellipsis div:nth-child(1) {
        left: 0;
        animation: lds-ellipsis1 0.6s infinite;
      }
      .lds-ellipsis div:nth-child(2) {
        left: 0;
        animation: lds-ellipsis2 0.6s infinite;
      }
      .lds-ellipsis div:nth-child(3) {
        left: 2rem;
        animation: lds-ellipsis2 0.6s infinite;
      }
      .lds-ellipsis div:nth-child(4) {
        left: 4rem;
        animation: lds-ellipsis3 0.6s infinite;
      }
      @keyframes lds-ellipsis1 {
        0% {
          transform: scale(0);
        }
        100% {
          transform: scale(1);
        }
      }
      @keyframes lds-ellipsis3 {
        0% {
          transform: scale(1);
        }
        100% {
          transform: scale(0);
        }
      }
      @keyframes lds-ellipsis2 {
        0% {
          transform: translate(0, 0);
        }
        100% {
          transform: translate(2rem, 0);
        }
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div class="loading">
      <div class="lds-ellipsis" aria-label="Loading">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>`;
    }
}
$fdb1f0370693292f$export$669f6ea7d267feaf = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-loading')
], $fdb1f0370693292f$export$669f6ea7d267feaf);






class $7540587fe4ca374c$export$f99233281efd08a0 extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {};
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$d836555d4d3fc310),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .title {
        font-size: 3rem;
        font-weight: bold;
        text-align: center;
        font-family: var(--font-family);
        color: #000000;
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<h1 class="title">ReDoS Detector</h1>`;
    }
}
$7540587fe4ca374c$export$f99233281efd08a0 = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-title')
], $7540587fe4ca374c$export$f99233281efd08a0);






class $3292058f4feb1b99$export$682c179f50ab847d extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {
            version: {
                type: String
            }
        };
    }
    constructor(){
        super();
        this.version = '';
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$605d5d2be7156deb),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .version {
        font-size: 0.8rem;
        font-family: var(--font-family);
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div class="version">
      <a
        class="link"
        href="https://github.com/tjenkinson/redos-detector"
        target="_blank"
        rel="noopener"
        >${this.version ? `v${this.version}` : ''}</a
      >
    </div>`;
    }
}
$3292058f4feb1b99$export$682c179f50ab847d = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-version')
], $3292058f4feb1b99$export$682c179f50ab847d);






class $b2336402314f0ab5$export$393edc798c47379d extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {};
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$e98b8c2ec48aa0c8),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .description {
        font-size: 1rem;
        text-align: center;
        font-family: var(--font-family);
        color: #000000;
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<p class="description">
      A tool that tests with certainty if a regex pattern is safe from ReDoS
      attacks.
    </p>`;
    }
}
$b2336402314f0ab5$export$393edc798c47379d = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-description')
], $b2336402314f0ab5$export$393edc798c47379d);






var $920bd9ec8b92aac9$exports = {};
$920bd9ec8b92aac9$exports = $parcel$resolve("2VhPn");


class $1b6bb005a56b57dd$export$3541133d22a6bbaa extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {};
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$605d5d2be7156deb),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .logo {
        width: 3rem;
        height: 3rem;
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<a
      href="https://github.com/tjenkinson/redos-detector"
      target="_blank"
      rel="noopener"
      ><img
        class="logo"
        alt="GitHub Logo"
        src="${new URL($920bd9ec8b92aac9$exports).href}"
    /></a>`;
    }
}
$1b6bb005a56b57dd$export$3541133d22a6bbaa = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-gh-link')
], $1b6bb005a56b57dd$export$3541133d22a6bbaa);






class $9b1914bf58b19f4c$export$225f3823f4b67c0e extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {};
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$e98b8c2ec48aa0c8),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      .message {
        font-size: 1rem;
        font-family: var(--font-family);
        padding: 0.2rem 0.5rem;
        text-align: center;
      }
    `
        ];
    }
    render() {
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<p class="message">There are more results than shown here.</p>`;
    }
}
$9b1914bf58b19f4c$export$225f3823f4b67c0e = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-more-results-msg')
], $9b1914bf58b19f4c$export$225f3823f4b67c0e);



/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $07b306a196659446$export$be5234c0b764b6e0 = Symbol("Comlink.proxy");
const $07b306a196659446$export$39fb953702b7fcd7 = Symbol("Comlink.endpoint");
const $07b306a196659446$export$89981d4b8d9f48aa = Symbol("Comlink.releaseProxy");
const $07b306a196659446$export$ddc31dfe7c269837 = Symbol("Comlink.finalizer");
const $07b306a196659446$var$throwMarker = Symbol("Comlink.thrown");
const $07b306a196659446$var$isObject = (val)=>typeof val === "object" && val !== null || typeof val === "function";
/**
 * Internal transfer handle to handle objects marked to proxy.
 */ const $07b306a196659446$var$proxyTransferHandler = {
    canHandle: (val)=>$07b306a196659446$var$isObject(val) && val[$07b306a196659446$export$be5234c0b764b6e0],
    serialize (obj) {
        const { port1: port1, port2: port2 } = new MessageChannel();
        $07b306a196659446$export$9b7f6e342a8cbd38(obj, port1);
        return [
            port2,
            [
                port2
            ]
        ];
    },
    deserialize (port) {
        port.start();
        return $07b306a196659446$export$4997ffc0176396a6(port);
    }
};
/**
 * Internal transfer handler to handle thrown exceptions.
 */ const $07b306a196659446$var$throwTransferHandler = {
    canHandle: (value)=>$07b306a196659446$var$isObject(value) && $07b306a196659446$var$throwMarker in value,
    serialize ({ value: value }) {
        let serialized;
        if (value instanceof Error) serialized = {
            isError: true,
            value: {
                message: value.message,
                name: value.name,
                stack: value.stack
            }
        };
        else serialized = {
            isError: false,
            value: value
        };
        return [
            serialized,
            []
        ];
    },
    deserialize (serialized) {
        if (serialized.isError) throw Object.assign(new Error(serialized.value.message), serialized.value);
        throw serialized.value;
    }
};
/**
 * Allows customizing the serialization of certain values.
 */ const $07b306a196659446$export$ab8f1c00731ee83e = new Map([
    [
        "proxy",
        $07b306a196659446$var$proxyTransferHandler
    ],
    [
        "throw",
        $07b306a196659446$var$throwTransferHandler
    ]
]);
function $07b306a196659446$var$isAllowedOrigin(allowedOrigins, origin) {
    for (const allowedOrigin of allowedOrigins){
        if (origin === allowedOrigin || allowedOrigin === "*") return true;
        if (allowedOrigin instanceof RegExp && allowedOrigin.test(origin)) return true;
    }
    return false;
}
function $07b306a196659446$export$9b7f6e342a8cbd38(obj, ep = globalThis, allowedOrigins = [
    "*"
]) {
    ep.addEventListener("message", function callback(ev) {
        if (!ev || !ev.data) return;
        if (!$07b306a196659446$var$isAllowedOrigin(allowedOrigins, ev.origin)) {
            console.warn(`Invalid origin '${ev.origin}' for comlink proxy`);
            return;
        }
        const { id: id, type: type, path: path } = Object.assign({
            path: []
        }, ev.data);
        const argumentList = (ev.data.argumentList || []).map($07b306a196659446$var$fromWireValue);
        let returnValue;
        try {
            const parent = path.slice(0, -1).reduce((obj, prop)=>obj[prop], obj);
            const rawValue = path.reduce((obj, prop)=>obj[prop], obj);
            switch(type){
                case "GET" /* MessageType.GET */ :
                    returnValue = rawValue;
                    break;
                case "SET" /* MessageType.SET */ :
                    parent[path.slice(-1)[0]] = $07b306a196659446$var$fromWireValue(ev.data.value);
                    returnValue = true;
                    break;
                case "APPLY" /* MessageType.APPLY */ :
                    returnValue = rawValue.apply(parent, argumentList);
                    break;
                case "CONSTRUCT" /* MessageType.CONSTRUCT */ :
                    {
                        const value = new rawValue(...argumentList);
                        returnValue = $07b306a196659446$export$923f96dd5afa9ce6(value);
                    }
                    break;
                case "ENDPOINT" /* MessageType.ENDPOINT */ :
                    {
                        const { port1: port1, port2: port2 } = new MessageChannel();
                        $07b306a196659446$export$9b7f6e342a8cbd38(obj, port2);
                        returnValue = $07b306a196659446$export$c9b234447cf4ef7c(port1, [
                            port1
                        ]);
                    }
                    break;
                case "RELEASE" /* MessageType.RELEASE */ :
                    returnValue = undefined;
                    break;
                default:
                    return;
            }
        } catch (value) {
            returnValue = {
                value: value,
                [$07b306a196659446$var$throwMarker]: 0
            };
        }
        Promise.resolve(returnValue).catch((value)=>{
            return {
                value: value,
                [$07b306a196659446$var$throwMarker]: 0
            };
        }).then((returnValue)=>{
            const [wireValue, transferables] = $07b306a196659446$var$toWireValue(returnValue);
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
            if (type === "RELEASE" /* MessageType.RELEASE */ ) {
                // detach and deactive after sending release response above.
                ep.removeEventListener("message", callback);
                $07b306a196659446$var$closeEndPoint(ep);
                if ($07b306a196659446$export$ddc31dfe7c269837 in obj && typeof obj[$07b306a196659446$export$ddc31dfe7c269837] === "function") obj[$07b306a196659446$export$ddc31dfe7c269837]();
            }
        }).catch((error)=>{
            // Send Serialization Error To Caller
            const [wireValue, transferables] = $07b306a196659446$var$toWireValue({
                value: new TypeError("Unserializable return value"),
                [$07b306a196659446$var$throwMarker]: 0
            });
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
        });
    });
    if (ep.start) ep.start();
}
function $07b306a196659446$var$isMessagePort(endpoint) {
    return endpoint.constructor.name === "MessagePort";
}
function $07b306a196659446$var$closeEndPoint(endpoint) {
    if ($07b306a196659446$var$isMessagePort(endpoint)) endpoint.close();
}
function $07b306a196659446$export$4997ffc0176396a6(ep, target) {
    const pendingListeners = new Map();
    ep.addEventListener("message", function handleMessage(ev) {
        const { data: data } = ev;
        if (!data || !data.id) return;
        const resolver = pendingListeners.get(data.id);
        if (!resolver) return;
        try {
            resolver(data);
        } finally{
            pendingListeners.delete(data.id);
        }
    });
    return $07b306a196659446$var$createProxy(ep, pendingListeners, [], target);
}
function $07b306a196659446$var$throwIfProxyReleased(isReleased) {
    if (isReleased) throw new Error("Proxy has been released and is not useable");
}
function $07b306a196659446$var$releaseEndpoint(ep) {
    return $07b306a196659446$var$requestResponseMessage(ep, new Map(), {
        type: "RELEASE" /* MessageType.RELEASE */ 
    }).then(()=>{
        $07b306a196659446$var$closeEndPoint(ep);
    });
}
const $07b306a196659446$var$proxyCounter = new WeakMap();
const $07b306a196659446$var$proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry((ep)=>{
    const newCount = ($07b306a196659446$var$proxyCounter.get(ep) || 0) - 1;
    $07b306a196659446$var$proxyCounter.set(ep, newCount);
    if (newCount === 0) $07b306a196659446$var$releaseEndpoint(ep);
});
function $07b306a196659446$var$registerProxy(proxy, ep) {
    const newCount = ($07b306a196659446$var$proxyCounter.get(ep) || 0) + 1;
    $07b306a196659446$var$proxyCounter.set(ep, newCount);
    if ($07b306a196659446$var$proxyFinalizers) $07b306a196659446$var$proxyFinalizers.register(proxy, ep, proxy);
}
function $07b306a196659446$var$unregisterProxy(proxy) {
    if ($07b306a196659446$var$proxyFinalizers) $07b306a196659446$var$proxyFinalizers.unregister(proxy);
}
function $07b306a196659446$var$createProxy(ep, pendingListeners, path = [], target = function() {}) {
    let isProxyReleased = false;
    const proxy = new Proxy(target, {
        get (_target, prop) {
            $07b306a196659446$var$throwIfProxyReleased(isProxyReleased);
            if (prop === $07b306a196659446$export$89981d4b8d9f48aa) return ()=>{
                $07b306a196659446$var$unregisterProxy(proxy);
                $07b306a196659446$var$releaseEndpoint(ep);
                pendingListeners.clear();
                isProxyReleased = true;
            };
            if (prop === "then") {
                if (path.length === 0) return {
                    then: ()=>proxy
                };
                const r = $07b306a196659446$var$requestResponseMessage(ep, pendingListeners, {
                    type: "GET" /* MessageType.GET */ ,
                    path: path.map((p)=>p.toString())
                }).then($07b306a196659446$var$fromWireValue);
                return r.then.bind(r);
            }
            return $07b306a196659446$var$createProxy(ep, pendingListeners, [
                ...path,
                prop
            ]);
        },
        set (_target, prop, rawValue) {
            $07b306a196659446$var$throwIfProxyReleased(isProxyReleased);
            // FIXME: ES6 Proxy Handler `set` methods are supposed to return a
            // boolean. To show good will, we return true asynchronously ¯\_(ツ)_/¯
            const [value, transferables] = $07b306a196659446$var$toWireValue(rawValue);
            return $07b306a196659446$var$requestResponseMessage(ep, pendingListeners, {
                type: "SET" /* MessageType.SET */ ,
                path: [
                    ...path,
                    prop
                ].map((p)=>p.toString()),
                value: value
            }, transferables).then($07b306a196659446$var$fromWireValue);
        },
        apply (_target, _thisArg, rawArgumentList) {
            $07b306a196659446$var$throwIfProxyReleased(isProxyReleased);
            const last = path[path.length - 1];
            if (last === $07b306a196659446$export$39fb953702b7fcd7) return $07b306a196659446$var$requestResponseMessage(ep, pendingListeners, {
                type: "ENDPOINT" /* MessageType.ENDPOINT */ 
            }).then($07b306a196659446$var$fromWireValue);
            // We just pretend that `bind()` didn’t happen.
            if (last === "bind") return $07b306a196659446$var$createProxy(ep, pendingListeners, path.slice(0, -1));
            const [argumentList, transferables] = $07b306a196659446$var$processArguments(rawArgumentList);
            return $07b306a196659446$var$requestResponseMessage(ep, pendingListeners, {
                type: "APPLY" /* MessageType.APPLY */ ,
                path: path.map((p)=>p.toString()),
                argumentList: argumentList
            }, transferables).then($07b306a196659446$var$fromWireValue);
        },
        construct (_target, rawArgumentList) {
            $07b306a196659446$var$throwIfProxyReleased(isProxyReleased);
            const [argumentList, transferables] = $07b306a196659446$var$processArguments(rawArgumentList);
            return $07b306a196659446$var$requestResponseMessage(ep, pendingListeners, {
                type: "CONSTRUCT" /* MessageType.CONSTRUCT */ ,
                path: path.map((p)=>p.toString()),
                argumentList: argumentList
            }, transferables).then($07b306a196659446$var$fromWireValue);
        }
    });
    $07b306a196659446$var$registerProxy(proxy, ep);
    return proxy;
}
function $07b306a196659446$var$myFlat(arr) {
    return Array.prototype.concat.apply([], arr);
}
function $07b306a196659446$var$processArguments(argumentList) {
    const processed = argumentList.map($07b306a196659446$var$toWireValue);
    return [
        processed.map((v)=>v[0]),
        $07b306a196659446$var$myFlat(processed.map((v)=>v[1]))
    ];
}
const $07b306a196659446$var$transferCache = new WeakMap();
function $07b306a196659446$export$c9b234447cf4ef7c(obj, transfers) {
    $07b306a196659446$var$transferCache.set(obj, transfers);
    return obj;
}
function $07b306a196659446$export$923f96dd5afa9ce6(obj) {
    return Object.assign(obj, {
        [$07b306a196659446$export$be5234c0b764b6e0]: true
    });
}
function $07b306a196659446$export$f2c03fb5a6c19546(w, context = globalThis, targetOrigin = "*") {
    return {
        postMessage: (msg, transferables)=>w.postMessage(msg, targetOrigin, transferables),
        addEventListener: context.addEventListener.bind(context),
        removeEventListener: context.removeEventListener.bind(context)
    };
}
function $07b306a196659446$var$toWireValue(value) {
    for (const [name, handler] of $07b306a196659446$export$ab8f1c00731ee83e)if (handler.canHandle(value)) {
        const [serializedValue, transferables] = handler.serialize(value);
        return [
            {
                type: "HANDLER" /* WireValueType.HANDLER */ ,
                name: name,
                value: serializedValue
            },
            transferables
        ];
    }
    return [
        {
            type: "RAW" /* WireValueType.RAW */ ,
            value: value
        },
        $07b306a196659446$var$transferCache.get(value) || []
    ];
}
function $07b306a196659446$var$fromWireValue(value) {
    switch(value.type){
        case "HANDLER" /* WireValueType.HANDLER */ :
            return $07b306a196659446$export$ab8f1c00731ee83e.get(value.name).deserialize(value.value);
        case "RAW" /* WireValueType.RAW */ :
            return value.value;
    }
}
function $07b306a196659446$var$requestResponseMessage(ep, pendingListeners, msg, transfers) {
    return new Promise((resolve)=>{
        const id = $07b306a196659446$var$generateUUID();
        pendingListeners.set(id, resolve);
        if (ep.start) ep.start();
        ep.postMessage(Object.assign({
            id: id
        }, msg), transfers);
    });
}
function $07b306a196659446$var$generateUUID() {
    return new Array(4).fill(0).map(()=>Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16)).join("-");
}


const $8ddbaaa8faff7e03$export$bd75b6d981b9c7f2 = Symbol('aborted');
var $846a6d8e2f6e9540$exports = {};
var $cc1fb55241d7aff9$exports = {};
"use strict";
$cc1fb55241d7aff9$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $846a6d8e2f6e9540$var$url = new URL($parcel$resolve("aqvxB"));
$846a6d8e2f6e9540$exports = $cc1fb55241d7aff9$exports($846a6d8e2f6e9540$var$url.toString(), $846a6d8e2f6e9540$var$url.origin, true);


function $8ddbaaa8faff7e03$export$2409b27812872cc9(pattern, flag) {
    const worker = new Worker($846a6d8e2f6e9540$exports);
    const calculateWorker = $07b306a196659446$export$4997ffc0176396a6(worker);
    let onAbort;
    const abortedPromise = new Promise((_, _onAbort)=>{
        onAbort = ()=>_onAbort($8ddbaaa8faff7e03$export$bd75b6d981b9c7f2);
    });
    const fakeDelay = new Promise((resolve)=>setTimeout(()=>resolve(), 200));
    return {
        abort: ()=>{
            onAbort();
            worker.terminate();
            calculateWorker[$07b306a196659446$export$89981d4b8d9f48aa]();
        },
        result: Promise.race([
            abortedPromise,
            calculateWorker(pattern, flag).then(async (res)=>{
                await fakeDelay;
                return res;
            })
        ])
    };
}


const $b3115e3dcb786a7f$var$resultsLimit = 20;
function $b3115e3dcb786a7f$var$score(score) {
    return score.infinite ? Infinity : score.value;
}

class $b3115e3dcb786a7f$export$be92b6f5f03c0fe9 extends (0, $eaddb0c0aed379ed$export$3f2f9f5909897157) {
    static{
        this.properties = {
            pattern: {
                type: String,
                noAccessor: true
            },
            flag: {
                type: String,
                noAccessor: true
            },
            _highlightA: {
                state: true
            },
            _highlightB: {
                state: true
            },
            _included: {
                state: true
            },
            _result: {
                state: true
            },
            _version: {
                state: true
            }
        };
    }
    static{
        this.styles = [
            (0, $1de3babb91df13b2$export$ed32643c9618a26),
            (0, $1de3babb91df13b2$export$5e032988b71f6158),
            (0, $1de3babb91df13b2$export$5d481d1cf311f83f),
            (0, $9183d483313437e5$export$dbf350e5966cf602)`
      :host {
        --source-color: #f0f0f0;
        --a-side-color: #ff0000;
        --b-side-color: #ffa000;
        --font-family: Arial;
      }

      .root {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        padding: 0.5rem;
      }

      .body {
        flex-grow: 1;
      }

      .footer {
        flex-shrink: 0;
        text-align: right;
      }

      .version {
        display: inline-block;
      }

      .header {
        position: sticky;
        background-color: #ffffff;
        top: 0;
        z-index: 1;
        margin-bottom: 1rem;
      }

      .header .fade {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        height: 1rem;
        background-image: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 1) 10%,
          rgba(255, 255, 255, 0) 100%
        );
      }

      .heading {
        display: flex;
        gap: 0.8em;
        flex-wrap: wrap;
        justify-content: center;
      }

      .description,
      .pattern,
      .messages,
      .input {
        margin-top: 0.4rem;
      }

      .loading {
        padding-top: 0.5rem;
      }

      .pattern,
      .results {
        text-align: center;
      }

      .results {
        margin-top: -1rem;
      }

      .result {
        display: inline-block;
        margin: 1rem;
        text-align: center;
        vertical-align: top;
      }
    `
        ];
    }
    get pattern() {
        return this._pattern || '';
    }
    set pattern(value) {
        const old = this._pattern;
        if (old === value) return;
        this._pattern = value;
        this._runCalculation();
        this.requestUpdate('pattern', old);
        if (old !== null) this._dispatchChange();
    }
    get flag() {
        return this._flag ?? '';
    }
    set flag(value) {
        const old = this._flag;
        if (old === value) return;
        this._flag = value;
        this._runCalculation();
        this.requestUpdate('flag', old);
        if (old !== null) this._dispatchChange();
    }
    constructor(){
        super(), this._inputRef = (0, $6c8e96a4880b3422$export$7d1e3a5e95ceca43)(), this._pattern = null, this._flag = null;
        this._calculateHandle = null;
        this._version = null;
        this._highlightA = new Set();
        this._highlightB = new Set();
        this._result = {
            type: 'loading'
        };
    }
    _dispatchChange() {
        const event = new CustomEvent('my-change', {
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(event);
    }
    _runCalculation() {
        this._result = {
            type: 'loading'
        };
        this._calculateHandle?.abort();
        this._calculateHandle = (0, $8ddbaaa8faff7e03$export$2409b27812872cc9)(this.pattern, this.flag);
        this._calculateHandle.result.then(async (result)=>{
            this._result = result;
        }).catch((e)=>{
            if (e === (0, $8ddbaaa8faff7e03$export$bd75b6d981b9c7f2)) return;
            throw e;
        });
    }
    connectedCallback() {
        super.connectedCallback();
        (parcelRequire("22TSl")).then(({ version: version })=>{
            this._version = version;
        });
    }
    _onPatternChange() {
        this.pattern = this._inputRef.value.value;
        this.flag = this._inputRef.value.flag;
    }
    _onSelectionChange() {
        this._updateHighlighted();
    }
    _updateHighlighted() {
        const els = this.shadowRoot.querySelectorAll('my-result');
        const highlightA = new Set();
        const highlightB = new Set();
        els.forEach((el)=>{
            el.highlightedA.forEach((offset)=>highlightA.add(offset));
            el.highlightedB.forEach((offset)=>highlightB.add(offset));
        });
        if (!(0, $a97ac150c5d82f70$export$62c3ee984ad46566)(this._highlightA, highlightA)) this._highlightA = highlightA;
        if (!(0, $a97ac150c5d82f70$export$62c3ee984ad46566)(this._highlightB, highlightB)) this._highlightB = highlightB;
    }
    updated() {
        this._updateHighlighted();
    }
    render() {
        const result = this._result?.type === 'result' ? this._result : null;
        const errorMessage = this._result?.type === 'error' ? this._result.message : null;
        return (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`
      <div class="root">
        <div class="body">
          <div class="heading">
            <my-title class="title"></my-title>
            <my-gh-link class="link"></my-gh-link>
          </div>
          <my-description class="description"></my-description>
          <my-input
            class="input"
            data-nosnippet
            ${(0, $6c8e96a4880b3422$export$eff4d24c3ff7876e)(this._inputRef)}
            .value=${this.pattern}
            .flag=${this.flag}
            @my-change=${this._onPatternChange}
          ></my-input>

          <div class="header">
            <div class="fade"></div>
            <div class="messages">
              ${this._result.type === 'loading' ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div class="loading">
                    <my-loading></my-loading>
                  </div>` : ''}
              ${result?.result.safe ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div>
                    <my-redos-safe
                      .score=${$b3115e3dcb786a7f$var$score(result.result.score)}
                    ></my-redos-safe>
                  </div>` : ''}
              ${result && !result.result.safe ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`
                    <div>
                      <my-redos-unsafe
                        .maybe=${result.result.trails.length === 0}
                        .score=${$b3115e3dcb786a7f$var$score(result.result.score)}
                      ></my-redos-unsafe>
                    </div>
                  ` : ''}
              ${result?.result.error ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div>
                    <my-redos-error
                      .error="${result.result.error}"
                    ></my-redos-error>
                  </div>` : ''}
              ${errorMessage ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div>
                    <my-error .message=${errorMessage}></my-error>
                  </div>` : ''}
            </div>
            ${result && result.result.trails.length ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`
                  <div class="pattern">
                    <my-pattern
                      .pattern=${result.result.pattern}
                      .highlightA=${[
            ...this._highlightA
        ]}
                      .highlightB=${[
            ...this._highlightB
        ]}
                      .included=${[
            ...result.included
        ]}
                    ></my-pattern>
                  </div>
                ` : ''}
          </div>
          ${result?.result.trails.length ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`
                <div class="results">
                  ${result.result.trails.slice(0, $b3115e3dcb786a7f$var$resultsLimit).map((trail)=>(0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<div class="result">
                        <my-result
                          .trail=${trail}
                          @my-result-change=${this._onSelectionChange}
                        ></my-result>
                      </div>`)}
                </div>
              ` : ''}
          ${result && result.result.trails.length > $b3115e3dcb786a7f$var$resultsLimit ? (0, $e943a7bafefa26a3$export$c0bb0b647f701bb5)`<my-more-results-msg></my-more-results-msg>` : ''}
        </div>
        <footer class="footer">
          <div class="version">
            <my-version version="${this._version || ''}"></my-version>
          </div>
        </footer>
      </div>
    `;
    }
}
$b3115e3dcb786a7f$export$be92b6f5f03c0fe9 = (0, $a6c50b5ab0875945$export$29e00dfd3077644b)([
    (0, $1c44ca1ea1f2dbb3$export$da64fc29f17f9d0e)('my-root')
], $b3115e3dcb786a7f$export$be92b6f5f03c0fe9);




//# sourceMappingURL=repo.f5dfb7c7.js.map
